export default __webpack_public_path__ + "static/media/eye-slash-icon.c8e37612.svg";